//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import choiceService from './choiceService';

export const getFaq = async () => {
    try {
        const url = `/v1.0/faq`;
        const res = await choiceService.get(url);
        return (res.data);
    } catch (error) {
        console.error(" error trying to getFaq");
        return (undefined);
    }
}
